import { getErrorMessage } from './networkDispatcher';

let nextRequestId = 0;

// Keep request identity with both outcomes so a slower response cannot replace a newer selection.
export default ({
  dispatch,
  requestType,
  successType,
  errorType,
  promise,
  responseName,
  defaultErrorMessage,
  metadata = {},
}) => {
  nextRequestId += 1;
  const requestId = nextRequestId;
  dispatch({
    ...metadata,
    type: requestType,
    requestId,
  });
  promise.then((response) => {
    dispatch({
      ...metadata,
      type: successType,
      requestId,
      [responseName]: response,
    });
  }).catch((error) => {
    dispatch({
      ...metadata,
      type: errorType,
      requestId,
      error: getErrorMessage({
        error,
        defaultErrorMessage,
      }),
    });
  });
  return promise;
};
